import { GET_LEARNING_TASK_LIST } from "../actions";

const initialState = {
  taskList: [],
};

const learningReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEARNING_TASK_LIST:
      return {
        ...state,
        taskList: action.payload,
      };
    default:
      return state;
  }
};

export default learningReducer;
